<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.gradient-text-one {
  background-image: -webkit-linear-gradient(#85fdff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;border: 1px #636363 solid;" :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#202027' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;border-bottom: 1px #636363 solid;padding: 10px;" :style="{ 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC' }">
      <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
        <p class="gradient-text-one" style="font-size: 18px;font-weight: 600;line-height: 22px;">
          {{ $t("gongchangxinxi") }}
        </p>
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <div v-if="info" style="display: flex;color: white;padding: 16px;box-sizing: border-box;flex: 1;height: 100%;">
        <div style="display: flex;flex-direction: column;justify-content: space-around;background-size: 100% 100%;background: #121212;border: 1px #636363 solid;" :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
          <!--background-image: url(/assets/img/monitor/workshop-senmusi/kuang.png);-->
          <div style="padding: 0 20px;flex: 1;display:flex;flex-direction: column;justify-content: center;align-items: center;">
            <p style="font-weight: bold;font-size: 16px;margin: 0;">{{ $t("zaizhigongdanjihuashu") }}</p>
            <p style="font-weight: bold;font-size: 28px;margin-top: 4px;">
              {{ info.zaizhigondanjihuashu }}
              <!-- {{ factoryData.unfinishedPlanCount ? factoryData.unfinishedPlanCount : "-" }} -->
            </p>
          </div>
          <div style="padding: 0 20px;flex: 1;display:flex;flex-direction: column;justify-content: center;align-items: center;">
            <p style="font-weight: bold;font-size: 16px;margin: 0;">{{ $t("zanzhigongdanshu") }}</p>
            <p style="font-weight: bold;font-size: 28px;margin-top: 4px;"><!-- {{ factoryData.producingWo ? factoryData.producingWo : "-" }} -->{{ info.zaizhigondanshu }}</p>
          </div>

          <div style="padding: 0 20px;flex: 1;display:flex;flex-direction: column;justify-content: center;align-items: center;">
            <p style="font-weight: bold;font-size: 16px;margin: 0;">{{ $t("zanzhigongdanshengchanshu") }}</p>
            <p style="font-weight: bold;font-size: 28px;margin-top: 4px;"><!-- {{ factoryData.woFinishedQty ? factoryData.woFinishedQty : "-" }} -->{{ info.zaizhigondanshengchanshu }}</p>
          </div>

          <div style="padding: 0 20px;flex: 1;display:flex;flex-direction: column;justify-content: center;align-items: center;">
            <p style="font-weight: bold;font-size: 16px;margin: 0;">{{ $t("jinrigongdanchanchushu") }}</p>
            <p style="font-weight: bold;font-size: 28px;margin-top: 4px;"><!-- {{ factoryData.todayReportSum ? factoryData.todayReportSum : "-" }} -->{{ info.jinrigondanchanchushu }}</p>
          </div>
        </div>
        <div style="flex: 1;height: 100%;display: flex;justify-content: center;align-items: center;margin: 0px 10px;">
          <img style="width: 100%;height: auto;" src="../../../../assets/img/web/manufacturing/gongchang.png" />
        </div>

        <div style="display: flex;flex-direction: column;justify-content: space-around;background-size: 100% 100%;background: #121212;border: 1px #636363 solid;" :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
          <div style="padding: 0 20px;flex: 1;display:flex;flex-direction: column;justify-content: center;align-items: center;">
            <p style="font-weight: bold;font-size: 16px;margin: 0;">{{ $t("daipaichanjihuashu") }}</p>
            <p style="font-weight: bold;font-size: 28px;margin-top: 4px;"><!-- {{ factoryData.pendingPlan ? factoryData.pendingPlan : "-" }} -->{{ info.daipaichanjihuashu }}</p>
          </div>

          <div style="padding: 0 20px;flex: 1;display:flex;flex-direction: column;justify-content: center;align-items: center;">
            <p style="font-weight: bold;font-size: 16px;margin: 0;">{{ $t("gongdanzhixingshu") }}</p>
            <p style="font-weight: bold;font-size: 28px;margin-top: 4px;"><!-- {{ factoryData.woExecQty ? factoryData.woExecQty : "-" }} -->{{ info.gondanzhixingshu }}</p>
          </div>

          <div style="padding: 0 20px;flex: 1;display:flex;flex-direction: column;justify-content: center;align-items: center;">
            <p style="font-weight: bold;font-size: 16px;margin: 0;">{{ $t("gongdanliangpinlv") }}</p>
            <p style="font-weight: bold;font-size: 28px;margin-top: 4px;"><!-- {{ factoryData.goodRate ? factoryData.goodRate : "-" }} -->{{ (info.gondanliangpinlv * 100).toFixed(1) }}%</p>
          </div>

          <div style="padding: 0 20px;flex: 1;display:flex;flex-direction: column;justify-content: center;align-items: center;">
            <p style="font-weight: bold;font-size: 16px;margin: 0;">{{ $t("jinrigongdanwanchengshu") }}</p>
            <p style="font-weight: bold;font-size: 28px;margin-top: 4px;"><!-- {{ factoryData.todayFinishWo ? factoryData.todayFinishWo : "-" }} -->{{ info.jinrigondanwanchengshu }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_manufacturing_factory",
  components: {},
  watch: {
    "$attrs.orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    },
  },
  data() {
    return {
      timer: null,
      contentHeight: 0,
      info: {},
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 300000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get("/web/report/page/zhinengzhizao_gongchangxinxi?getOrgByParent=orgId", {
        params: {
          orgId: this.$attrs.orgId,
        },
      });
      this.info = response.data.rows[0];
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight;
      }, 800);
    },
  },
};
</script>
